
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import api from '../../../api'
import { ModalLayout } from '@appbase/templates'

/**
 * 웹파트 추가/편집 모달
 * 웹파트의 상세 설정을 수정할 수 있다.
 */
@Component({
    components: { ModalLayout },
})
export default class WebpartPreviewModal extends Vue {
    constructor() {
        super()
        this.closeCurrentModal = this.closeCurrentModal.bind(this)
    }

    @Prop({ type: Object, required: true }) webpart!: webpartv3.Webpart
      /** 웹파트 모달 타이틀 */
    @Prop({ type: String }) title!: string;

    loading: boolean = false
    modalSize: string = ''
    notfound: boolean = false

    async created() {}

    mounted() {
        this.notfound = !(this.$refs.comp instanceof Vue)
    }

    handleTest() {
        this.closeCurrentModal()
    }
}
